import { render, staticRenderFns } from "./PropertyNotificationSettings.vue?vue&type=template&id=720c2e86&scoped=true&"
import script from "./PropertyNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./PropertyNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./PropertyNotificationSettings.scss?vue&type=style&index=0&id=720c2e86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_@vue+compiler-sfc@3.5.11_babel-core@7.0.0-bridge.0_@babel+core@7.17.9_f17ab4d8c27c5d7082708fbbc2f82c9d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720c2e86",
  null
  
)

export default component.exports